export default "__VITE_PUBLIC_ASSET__f5bbae6d__"